import axios from 'axios';

export const clientsService={
    createOrUpdate
}
function createOrUpdate(newContact) {
    let url = `${
      process.env.REACT_APP_API_URL
    }/api/contacts${newContact.id ? `/${newContact.id}` : ''}`;
    const requestOptions = {
      method: newContact.id ? 'PUT' : 'POST',
      url,
      headers: {
        Accept: 'application/json'
      },
      data:  createBodyRequest(newContact)
    };

    return axios(requestOptions);
  }

  function createBodyRequest(contactData) {
    let formData = new FormData();

    formData.append('contact[name]', contactData.name);
    formData.append('contact[email]', contactData.email);
    formData.append('contact[phone]', contactData.phone);
    formData.append('contact[message]', contactData.message);

    return formData;
}
